export default function shopPromotion({main, on, elm}) {
	const heroSection = document.querySelector('hero-section');

	main(_ => {
		init();

		on('click', '[data-close]', close);
	});

	const init = function () {
		const observer = new IntersectionObserver(([entry]) => {
			elm.classList.toggle('discount--floating', !entry.isIntersecting);
		}, {
			threshold: 0
		});

		observer.observe(heroSection);
	};

	const close = async function () {
		if (!window.hasOwnProperty('cookieStore'))
			await import('cookie-store');

		const day = 24 * 60 * 60 * 1000;
		await cookieStore.set({
			name: 'promotion',
			value: 1,
			expires: Date.now() + day * 3,
			sameSite: "lax"
		});

		elm.remove();
	};
};

export const model = {};
